export default __webpack_public_path__ + "static/media/martin_reel.8d19bd1c.jpg";